import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_FORMS, PATH_FORM_BUILDER } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import { getRelativePath } from "@/utils/paths";

const FormsContainer = lazy(() => import("@pages/forms/forms.container"));
const FormBuilderContainer = lazy(() => import("@pages/forms/forms.builder.container"));

const formRoutes = [
  {
    path: PATH_FORMS,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        element: <FormsContainer />,
        index: true,
      },
      {
        path: getRelativePath(PATH_FORMS, PATH_FORM_BUILDER),
        element: <FormBuilderContainer />,
      },
    ],
  },
];

export default formRoutes;
